import passengerTrafficData from '../assets/temp/PassengerTrafficRoadTransport.json'
import cargoTurneverData from '../assets/temp/CargoTurnever.json'
import AgeOfTheFleetOfRoadMechanicalVehicleData from '../assets/temp/AgeOfTheFleetOfRoadMechanicalVehicle.json'
import wasteGenerationBySourceData from '../assets/temp/WasteGenerationBySource.json'
import householdWastePerCapitaData from '../assets/temp/HouseholdWastePerCapita.json'
import HazardousWasteManagementData from '../assets/temp/HazardousWasteManagement.json'
import IndicatorListData from "../assets/temp/IndicatorList.json"

const passengerTraffic = () => {
  return passengerTrafficData
}

const cargoTurnever = () => {
  return cargoTurneverData
}

const ageRoadMechanicalVehicle = () => {
  return AgeOfTheFleetOfRoadMechanicalVehicleData
}

const wasteGenerationBySource = () => {
  return wasteGenerationBySourceData
}

const householdWastePerCapita = () => {
  return householdWastePerCapitaData
}

const hazardousWasteManagement = () => {
  return HazardousWasteManagementData
}

const indicatorList = () => {
  return IndicatorListData
}

export default {
  passengerTraffic,
  cargoTurnever,
  ageRoadMechanicalVehicle,
  wasteGenerationBySource,
  householdWastePerCapita,
  hazardousWasteManagement,
  indicatorList
}